import {Component, OnInit} from '@angular/core';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {NavigationEnd, Router, RouterLink, RouterLinkActive} from '@angular/router';
import {filter} from 'rxjs';
import {NgClass} from '@angular/common';

@Component({
  selector: 'gr-landing-footer',
  templateUrl: './landing-footer.component.html',
  imports: [
    RouterLink,
    RouterLinkActive,
    NgClass
  ],
  standalone: true
})
export class LandingFooterComponent implements OnInit {
  activeFooterClass = '';
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        console.log(this.router.url);
        if (this.router.url === PAGES_AND_PATHS.landingAboutUs.pagePath || this.router.url === PAGES_AND_PATHS.landingForBusinesses.pagePath) {
          this.activeFooterClass = 'purple';
        } else if (this.router.url === PAGES_AND_PATHS.landingBlog.pagePath || this.router.url === PAGES_AND_PATHS.landingContact.pagePath) {
          this.activeFooterClass = 'blue';
        } else {
          this.activeFooterClass = '';
        }
      });
  }
}
